import React, {Component, Fragment} from 'react';
import moment from 'moment';
import createRTIRefundOrderMutation from 'graphql/mutations/orders/create-rti-dealer-refund-order.gql';
import SectionBanner from 'components/section-banner';
import SectionTitle from 'components/section-title';
import OptionsSidebar from 'components/options-sidebar';
import {Form, Field, Input, Textarea, DateInput} from 'components/forms';
import {gt} from 'components/forms/form/validators';
import Button from 'components/button';
import {refundForm} from 'components/forms/decorators';
import styles from './styles.css';

@refundForm(createRTIRefundOrderMutation)
export default class RTIDealerRefundCreate extends Component {
    render() {
        return (
            <div className={styles.root}>
                <SectionBanner />
                <SectionTitle title='RTI' />
                <div className={styles.gridContainer}>
                    <OptionsSidebar refundType='rti' userType='dealer' links={['refund', 'kits']} />
                    <div className={styles.formContainer}>
                        <Form
                            fields={[
                                {key: 'date'},
                                {key: 'estimatedAmount', validators: [gt(0)]},
                                {key: 'attendees', validators: [gt(0)]},
                                {key: 'notes', required: false},
                            ]}
                            errors={this.props.errors}
                            onSubmit={this.props.onSubmit}>
                            {({getFieldProps, renderErrors, isValid}) => (
                                <Fragment>
                                    <div className={styles.title}>Solicitud de Presupuesto de Jornada</div>
                                    <Field label='Fecha estimada'>
                                        <DateInput min={moment().format('YYYY-MM-DD')} {...getFieldProps('date')} />
                                        {renderErrors('date')}
                                    </Field>
                                    <Field label='Presupuesto estimado en pesos'>
                                        <Input type='number' {...getFieldProps('estimatedAmount')} />
                                        {renderErrors('estimatedAmount')}
                                    </Field>
                                    <Field label='Cantidad estimada de invitados'>
                                        <Input type='number' {...getFieldProps('attendees')} />
                                        {renderErrors('attendees')}
                                    </Field>
                                    <Field label='Comentarios para Nidera'>
                                        <Textarea {...getFieldProps('notes')} />
                                        {renderErrors('notes')}
                                    </Field>
                                    {renderErrors('__all__')}
                                    <Form.Actions>
                                        <Button theme='yellow' disabled={!isValid() || this.props.loading}>
                                            {this.props.loading ? 'ENVIANDO...' : 'ENVIAR'}
                                        </Button>
                                    </Form.Actions>
                                </Fragment>
                            )}
                        </Form>
                    </div>
                </div>
            </div>
        );
    }
}



// WEBPACK FOOTER //
// ./views/refunds/rti-dealer/refund/index.js